// src/services/user-details.service.ts
import axios, { AxiosError } from 'axios';
import { environment } from '../config/environment';
import { convertToReactCountryCode } from './transformers';
import { UserDetails } from './user.types';

export class UserDetailsError extends Error {
    constructor(
        message: string,
        public readonly statusCode?: number,
        public readonly response?: any
    ) {
        super(message);
        this.name = 'UserDetailsError';
    }
}

export const getUserDetails = async (token: string): Promise<UserDetails> => {
    if (!token) {
        throw new UserDetailsError('Authentication token is required');
    }

    try {
        const response = await axios.get<UserDetails>(`${environment.ctLiteApiUrl}/user/details`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.data) {
            throw new UserDetailsError('No data received from server');
        }

        return convertToReactCountryCode(response.data);
    } catch (error) {
        if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError;
            throw new UserDetailsError(axiosError.message, axiosError.response?.status, axiosError.response?.data);
        }
        throw new UserDetailsError('Failed to fetch user details');
    }
};
